import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import { PlanoService } from "../../../services/PlanoService";
import StandardPagination from "../../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../../components/actions/ActionButtons.vue";

export default {
    name: "GerenciarPlanos",
    components: {
        Breadcrumb,
        StandardPagination,
        ActionButtons
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Planos de Aquisição',
                disabled: false
            },
            {
                text: 'Gerenciar Planos de Aquisição',
                disabled: true
            }
        ],
        headers: [      
            { text: 'Descrição', align: 'center', value: 'descricao', sortable: true },
            { text: 'Documento SEI', align: 'center', value: 'documento_sei', sortable: true },
            { text: 'Elaborador', align: 'center', value: 'elaborador', sortable: true },
            { text: 'Nome Plano', align: 'center', value: 'nome', sortable: true },
            { text: 'Status', align: 'center', value: 'status', sortable: true },
            { text: 'Valor', align: 'center', value: 'valor', sortable: true },
            { text: 'Validade', align: 'center', value: 'validade', sortable: true },
        ],
        filters: {
            descricaoFilter: '',
            documentoSeiFilter: '',
            elaboradorFilter: '',
            nomeFilter: '',
            valorFilter: '',
            statusFilter: ''
        },
        statusOptions: [
            { text: 'CONSOLIDADO', value: 'CONSOLIDADO' },
            { text: 'RASCUNHO', value: 'RASCUNHO' }
        ],
        items: [],
        itemSelected: [],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50, 100],
        showFilters: true,
        statusMapping: {
            'CONSOLIDADO': { text: 'CONSOLIDADO', color: 'green' },
            'RASCUNHO': { text: 'RASCUNHO', color: 'orange' }
        }
    }),
    computed: {
        computedHeaders() {
            return this.headers;
        },
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        }
    },
    created() {
        this.listarPlanosPaginado();
    },
    watch: {
        'filters.descricaoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1; // Reset para primeira página ao filtrar
                this.listarPlanosPaginado();
            }
        },
        'filters.documentoSeiFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPlanosPaginado();
            }
        },
        'filters.elaboradorFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPlanosPaginado();
            }
        },
        'filters.nomeFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPlanosPaginado();
            }
        },
        'filters.valorFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPlanosPaginado();
            }
        },
        'filters.statusFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPlanosPaginado();
            }
        }
    },
    methods: {
        async listarPlanosPaginado() {
            try {
                const filter = this.prepareFormFilter();

                const response = await PlanoService.index(filter);

                if (typeof response !== 'string' && response && response.data) {
                    this.items = response.data.data || [];
                    this.totalItems = response.data.total || 0;
                    this.itemSelected = [];
                } else {
                    this.items = [];
                    this.totalItems = 0;
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os planos:', error);
                this.items = [];
                this.totalItems = 0;
            }
        },
        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            if (this.filters.descricaoFilter) {
                filter.append("descricao", this.filters.descricaoFilter);
            }
            if (this.filters.documentoSeiFilter) {
                filter.append("documento_sei", this.filters.documentoSeiFilter);
            }
            if (this.filters.elaboradorFilter) {
                filter.append("elaborador", this.filters.elaboradorFilter);
            }
            if (this.filters.nomeFilter) {
                filter.append("nome", this.filters.nomeFilter);
            }
            if (this.filters.valorFilter) {
                filter.append("valor", this.filters.valorFilter);
            }
            if (this.filters.statusFilter) {
                filter.append("status", this.filters.statusFilter);
            }

            return filter;
        },
        async downloadPlano() {
            if (this.itemSelected.length > 0) {
                return await PlanoService.download(this.itemSelected[0].id);
            }
        },
        handleVisualizarPlano() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/montar-plano-aquisicao/${this.itemSelected[0].id}`);
            }
        },
        handlePageChange(newPage) {
            this.page = newPage;
            this.listarPlanosPaginado();
        },
        handleItemsPerPageChange(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarPlanosPaginado();
        },
        onSelectionChanged(selectedItems) {
            this.itemSelected = selectedItems;
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },
        getStatusColor(status) {
            const mapping = this.statusMapping[status];
            return mapping ? mapping.color : 'grey';
        },
        formatCurrency(value) {
            if (!value && value !== 0) return 'R$ 0,00';
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        formatDate(dateString) {
            if (!dateString) return '-';
            try {
                const date = new Date(dateString);
                return date.toLocaleDateString('pt-BR');
            } catch (error) {
                return dateString;
            }
        },
        clearFilters() {
            this.filters = {
                descricaoFilter: '',
                documentoSeiFilter: '',
                elaboradorFilter: '',
                nomeFilter: '',
                valorFilter: '',
                statusFilter: ''
            };
            this.page = 1;
            this.listarPlanosPaginado();
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        getRowClass() {
            return 'standard-table-row';
        }
    }
}